

export default {
    Features: [
        "Questions",
        "AI score",
        "CEFR Checker",
        "Explanation",
        "Notebook",
        "My vocabulary",
        "Practice Statistics",
        "Vocabulary Lists",
        "Fast scoring",
        "Dictionary",
        "Detection mode",
        "International languages"
    ],
    Free: [
        "10 questions per day",
        "3 quotas",
        "Word",
        "X",
        "X",
        "X",
        "T",
        "T",
        "T",
        "T",
        "T",
        "T",
    ],
    VIP: [
        "15000+",
        "Unlimited (1.0 version)",
        "Word & Sentence",
        "T",
        "T",
        "T",
        "T",
        "T",
        "T",
        "T",
        "T",
        "T",
    ]
}